import React, {Component} from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';
import {withRouter} from 'react-router';

import search from '../../assets/icons/search-light.svg';
import searchDark from '../../assets/icons/search.svg';

class NewsSearch extends Component {
    constructor() {
        super();

        this.state = {
            searchValue: ''
        };
    };

    componentDidUpdate(prevProps, prevState) {
        const { clang, location } = this.props;

        if (clang !== prevProps.clang || location !== prevProps.location) {
            this.setState({searchValue: ''});
        }
    };

    componentWillUnmount() {
        this.setState({searchValue: ''});
    };

    handleChange = (event) => {
        this.setState({searchValue: event.target.value});
    };

    handleSubmit = (event) => {
        event.preventDefault();

        const {searchNews} = this.props;
        searchNews(this.state.searchValue);
    };

    render() {
        const { clang, isPageData } = this.props;

        return (
            <div className="news__search" onSubmit={this.handleSubmit}>
                <h2 className="news__search-title">{lang[clang].news.search}</h2>
                <span className="news__search-title--line"></span>
                <form className="news__search__form">
                    <div className="news__search__form-field">
                        <input
                            type="text"
                            name="key"
                            value={this.state.searchValue}
                            placeholder={lang[clang].characteristics.search}
                            onChange={this.handleChange}
                            className="news__search__form-input"
							title={ lang[ clang ].search.what }
						/>	
                    </div>
                    <button
                        title={lang[clang].search_for}
                        className="news__search__form-submit"
                        type="submit"
                        onClick={() => this.state.searchValue}
                        disabled={!isPageData}>
                        <img src={search} alt="" className="news__search__form-submit__img"/>
                        <img src={searchDark} alt="" className="news__search__form-submit__img hover"/>
                    </button>
                </form>
            </div>
        );
    }
};

NewsSearch.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default withRouter(connect(mapStateToProps)(NewsSearch));



// WEBPACK FOOTER //
// ./src/components/news/NewsSearch.js